import * as React from 'react';

import {getApiTypeFromGraphQLTypename} from 'nutshell-core/utils';

// @ts-expect-error - imported from .js/.jsx file

import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LimitedGroup} from 'shells/limited-group/limited-group';
import {Link} from 'shells/link/link';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

import type {GetActivity_activity as Activity} from 'nutshell-graphql-types';

import {GraphQLSelectActivityTypes} from '../../../core/select/graphql-select-activity-types';

import {appHistory} from '../../../../history';

import styles from './activity-log-modal.module.css';

type Props = {
    activity: Activity;
    activityTypeId: string;
    setActivityTypeId: (arg1: string) => void;
    onClose: () => void;
};

const localStyles = {
    // @ts-expect-error
    control: (base) => ({
        ...base,
        zIndex: 9,
        width: 140,
        height: 31,
    }),
} as const;

export function Header(props: Props) {
    return (
        <StackLegacy spacing={36}>
            <div className={styles['title-container']}>
                <Body truncate={{type: 'inline'}} isBold={true} color='dark'>
                    {props.activity.name}
                </Body>
                <div className={styles['title-button-container']}>
                    <Link
                        variant='primary'
                        size='mini'
                        onClick={() => {
                            props.onClose();
                            appHistory.replace({
                                ...appHistory.location,
                                hash: `/${props.activity.id}`,
                                state: {modal: true},
                            });
                        }}
                        icon={ExternalLinkIcon}
                    >
                        View full activity
                    </Link>
                </div>
            </div>
            <StackLegacy spacing={4}>
                <div className='flex align-center gap-4 full-width'>
                    <Body size='small'>Activity type:</Body>
                    <GraphQLSelectActivityTypes
                        // @ts-expect-error
                        labelId='ActivityTypePicker'
                        onChange={(selection) => props.setActivityTypeId(selection.id)}
                        selectedId={props.activityTypeId}
                        menuPlacement='auto'
                        autoFocus={false}
                        includeManageOption={true}
                        styles={localStyles}
                    />
                </div>
                {props.activity.startTime && props.activity.endTime && (
                    <StackLegacy spacing={4}>
                        <StackLegacy spacing={4} isHorizontal={true}>
                            <Body size='small' nowrap={true}>
                                Start time:
                            </Body>
                            <FormattedTimestamp
                                datetime={props.activity.startTime}
                                format={FormattedTimestamp.formats.longDateWithTime}
                            />
                        </StackLegacy>
                        <StackLegacy spacing={4} isHorizontal={true}>
                            <Body size='small' nowrap={true}>
                                End time:
                            </Body>
                            <FormattedTimestamp
                                datetime={props.activity.endTime}
                                format={FormattedTimestamp.formats.longDateWithTime}
                            />
                        </StackLegacy>
                    </StackLegacy>
                )}
                {props.activity.participants.length > 0 ? (
                    <StackLegacy spacing={8} isHorizontal={true}>
                        <Body size='small'>Participants:</Body>
                        <LimitedGroup
                            numDisplayed={4}
                            // @ts-expect-error
                            includeMoreWords={true}
                            shouldTruncate={true}
                            shouldFlex={true}
                            models={props.activity.participants.map((participant) => (
                                <div className='mr-8' key={participant.id}>
                                    <LinkedEntity
                                        useEntityColor={true}
                                        stopPropagation={true}
                                        type={getApiTypeFromGraphQLTypename(participant.__typename)}
                                        name={participant.name}
                                        htmlUrl={participant.htmlUrl}
                                        isLinkable={true}
                                        shouldClientRoute={true}
                                    />
                                </div>
                            ))}
                        />
                    </StackLegacy>
                ) : (
                    <Body size='small' isItalic={true}>
                        No participants
                    </Body>
                )}
                <div className='mt-8'>
                    <Divider variant='line--horizontal' />
                </div>
            </StackLegacy>
        </StackLegacy>
    );
}
